/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_2_TagInputs */

const en_mk_parts_2_tag = /** @type {(inputs: Mk_Parts_2_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 — Conversation`)
};

const id_mk_parts_2_tag = /** @type {(inputs: Mk_Parts_2_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 — Percakapan`)
};

/**
* | output |
* | --- |
* | "02 — Conversation" |
*
* @param {Mk_Parts_2_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_2_tag = /** @type {((inputs?: Mk_Parts_2_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_2_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_2_tag(inputs)
	return en_mk_parts_2_tag(inputs)
});